import axios from 'axios';

const token = localStorage.getItem('accessToken');

const apiPlatform = axios.create({
    baseURL: process.env.VUE_APP_PLATFORM_API,
    headers: { 'Authorization': `bearer ${token}`, 'X-Client-Identifier': "DnePay" }
});

export default apiPlatform;